import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CartProvider } from "./context/CartContext";
import { ContentProvider } from "./context/ContentContext";
import { CatalogProvider } from "./context/CatalogContext";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ContentProvider>
        <CatalogProvider>
          <CartProvider>
            <BrowserRouter basename={__BASE_PATH__}>
              <div className="overflow-x-hidden">
                <AppRoutes />
              </div>
            </BrowserRouter>
          </CartProvider>
        </CatalogProvider>
      </ContentProvider>
    </I18nextProvider>
  );
}

export default App;